import React from "react";
import { theme as themeConfig } from "../../themes/themes";
import { Header, ChatbotLogo, ChatbotText } from "./Chatbot.styled";

const Chatbot = () => {
  return (
    <>
      <div
        style={{
          position: "relative",
          height: "100%",
          padding: "5px 0px 0px 10px",
        }}
      >
        <Header>
          <ChatbotLogo>
            <svg
              width="40"
              height="40"
              viewBox="0 0 21 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5 0C16.275 0 21 3.77889 21 8.44444C21 13.11 16.275 16.8889 10.5 16.8889C9.198 16.8889 7.9485 16.6989 6.7935 16.3611C3.7275 19 0 19 0 19C2.4465 16.5406 2.835 14.8833 2.8875 14.25C1.1025 12.7406 0 10.6928 0 8.44444C0 3.77889 4.725 0 10.5 0ZM15.75 9.5V7.38889H13.65V9.5H15.75ZM11.55 9.5V7.38889H9.45V9.5H11.55ZM7.35 9.5V7.38889H5.25V9.5H7.35Z"
                fill={themeConfig.text.primary}
              />
            </svg>
          </ChatbotLogo>
          <ChatbotText>Chatbot</ChatbotText>
        </Header>
        <iframe
          src="https://ivafactorytest.teleperformance.co:3008/chatbot?project=longtest&template=longtest"
          permissions="geolocation notifications midi"
          width="500"
          height="650"
        ></iframe>
      </div>
    </>
  );
};

export default Chatbot;
